import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import axios from 'axios';

import MainLayout from "layouts/Main.js";
import LoginLayout from "layouts/LoginLayout.js";
// layout 추가 시 import 추가하고 Route 내 component 수정

import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";

if (window.location.hostname === "dev.einssnc.com" || window.location.hostname === "localhost") {
  axios.defaults.baseURL = '/GiGAtwinFactory';
} else {
  axios.defaults.baseURL = '/GiGAtwinFactory'
}

const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

ReactDOM.render(
  <Router history={history}>
    <Switch>
      <Route path="/user" component={LoginLayout} />
      <Route path="/admin" component={MainLayout} />
      <Route path="/people" component={MainLayout} />
      <Route path="/project" component={MainLayout} />
      <Route path="/aps" component={MainLayout} />
      <Route path="/mes" component={MainLayout} />
      <Redirect from="/" to="/project/main" />
    </Switch>
  </Router>,
  document.getElementById("root")
);